module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/specilization/specilization.component.css
// module id = ./src/app/Pages/manage/specilization/specilization.component.css
// module chunks = main